import { useSelector } from 'react-redux';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import InputTranslateButton from 'components/desktop/_general/Input/InputExtensions/InputTranslateButton/InputTranslateButton';
import SimpleInput from 'components/desktop/_general/Input/SimpleInput/SimpleInput';
import { usePermissions } from 'hooks/usePermissions';
import { RootState } from 'reducers/rootReducer';
import { Language } from 'types/Language/Language';

interface IProps {
	value: string;
	handleValueChange: (input: { cultureCode: string; value: string }) => void;
	onTranslateClick: (name: string) => void;
	selectedLanguage: string;
}

const IngredientLanguageInput = (props: IProps) => {
	const { isIngredientEditor } = usePermissions();

	const reduxLanguages: Language[] = useSelector((state: RootState) => state.languages);
	const reduxCultureCode: string = useSelector((state: RootState) => state.cultureCode);

	const isTranslatable = (): boolean => {
		if (!isIngredientEditor) return false;
		if (reduxLanguages && reduxCultureCode !== undefined) {
			if (reduxCultureCode === props.selectedLanguage) {
				return false;
			} else {
				return true;
			}
		}
		return false;
	};

	const renderContent = () => {
		return (
			<div className="input-group">
				<SimpleInput
					disabled={!isIngredientEditor}
					errorKey="NameTranslations"
					handleChange={(value) => {
						props.handleValueChange({
							cultureCode: props.selectedLanguage,
							value: value,
						});
					}}
					value={props.value}
				/>
				<RenderIf condition={isTranslatable()}>
					<InputTranslateButton
						name="nameTranslations"
						onClick={props.onTranslateClick}
					/>
				</RenderIf>
			</div>
		);
	};

	return <>{renderContent()}</>;
};

export default IngredientLanguageInput;
